import { useEffect, useState } from "react";
import EntityPage from "@/components/EntityPage";
import { StockBadge } from "@/components/StatusBadge";
import { api, euro, prezzoFinale, scontoLabel, CATEGORIE_RICAMBI, CATEGORIE_PRODOTTI } from "@/lib/api";

const Margine = ({ r }) => {
  if (!r.prezzo_acquisto) return <span className="text-xs text-slate-400">—</span>;
  const m = prezzoFinale(r) - r.prezzo_acquisto;
  return <span className={`font-mono text-xs font-bold ${m < 0 ? "text-rose-600" : "text-emerald-700"}`}>{euro(m)}</span>;
};

const fields = (categorie) => [
  { name: "codice", label: "Codice / SKU" },
  { name: "nome", label: "Nome", required: true },
  { name: "categoria", label: "Categoria", type: "select", options: categorie },
  { name: "marca", label: "Marca" },
  { name: "prezzo_acquisto", label: "Prezzo di acquisto (€)", type: "number", step: "0.01" },
  { name: "prezzo", label: "Prezzo di vendita (€ IVA incl.)", type: "number", step: "0.01" },
  { name: "sconto_tipo", label: "Tipo di sconto", type: "select", default: "percentuale", options: [{ value: "percentuale", label: "In percentuale (%)" }, { value: "euro", label: "In euro (€)" }] },
  { name: "sconto", label: "Sconto cliente (% o €)", type: "number", step: "0.01" },
  { name: "quantita", label: "Quantità disponibile", type: "number" },
  { name: "soglia_minima", label: "Soglia minima (avviso)", type: "number" },
  { name: "note", label: "Note", type: "textarea" },
];

const columns = [
  { key: "codice", label: "Codice", render: (r) => <span className="font-mono text-xs text-slate-500">{r.codice || "—"}</span> },
  { key: "nome", label: "Nome", render: (r) => <span className="font-semibold text-slate-900">{r.nome}</span> },
  { key: "categoria", label: "Categoria" },
  { key: "marca", label: "Marca" },
  { key: "prezzo_acquisto", label: "Acquisto", render: (r) => <span className="font-mono text-slate-500">{r.prezzo_acquisto ? euro(r.prezzo_acquisto) : "—"}</span> },
  { key: "prezzo", label: "Vendita", render: (r) => r.sconto ? (
    <span className="font-mono"><span className="text-xs text-slate-400 line-through">{euro(r.prezzo)}</span> <span className="font-bold">{euro(prezzoFinale(r))}</span> <span className="rounded-sm bg-orange-50 px-1 text-[11px] font-bold text-orange-700" data-testid={`sconto-badge-${r.id}`}>{scontoLabel(r)}</span></span>
  ) : <span className="font-mono">{euro(r.prezzo)}</span> },
  { key: "margine", label: "Margine", render: (r) => <Margine r={r} /> },
  { key: "quantita", label: "Disp.", render: (r) => <StockBadge quantita={r.quantita} soglia={r.soglia_minima} testId={`stock-${r.id}`} /> },
  { key: "soglia_minima", label: "Soglia", render: (r) => <span className="font-mono text-xs text-slate-500">{r.soglia_minima}</span> },
];

const useCategorie = (chiave, predefinite) => {
  const [cat, setCat] = useState(predefinite);
  useEffect(() => { api.get("/impostazioni").then((r) => setCat(r.data[chiave]?.length ? r.data[chiave] : predefinite)).catch(() => {}); }, [chiave, predefinite]);
  return cat;
};

export const Ricambi = () => {
  const cat = useCategorie("categorie_ricambi", CATEGORIE_RICAMBI);
  return <EntityPage overline="Magazzino" title="Ricambi" endpoint="ricambi" prefix="ricambi" singular="ricambio" newLabel="Nuovo ricambio" fields={fields(cat)} columns={columns} stock />;
};

export const Prodotti = () => {
  const cat = useCategorie("categorie_prodotti", CATEGORIE_PRODOTTI);
  return <EntityPage overline="Negozio" title="Prodotti" endpoint="prodotti" prefix="prodotti" singular="prodotto" newLabel="Nuovo prodotto" fields={fields(cat)} columns={columns} stock />;
};
